/* eslint-disable global-require */
/* eslint-disable @typescript-eslint/no-var-requires */

type LogMeta = Record<string, unknown>

type LoggerLike = {
  info: (message: string, meta?: LogMeta) => void
  error: (message: string, meta?: LogMeta) => void
  warn: (message: string, meta?: LogMeta) => void
  debug: (message: string, meta?: LogMeta) => void
}

const consoleLogger: LoggerLike = {
  info: (message, meta) => console.info(message, meta ?? ''),
  error: (message, meta) => console.error(message, meta ?? ''),
  warn: (message, meta) => console.warn(message, meta ?? ''),
  debug: (message, meta) => console.debug(message, meta ?? ''),
}

function createWinstonLogger(): LoggerLike {
  const winston = require('winston')
  return winston.createLogger({
    level: process.env.LOG_LEVEL || 'info',
    format: winston.format.combine(winston.format.timestamp(), winston.format.json()),
    defaultMeta: {
      service: 'carbon',
      env: process.env.ACKO_ENV,
    },
    transports: [new winston.transports.Console()],
  })
}

// Winston is Node-only (uses `fs`). Shared services are also imported by client
// components, so fall back to console in the browser and only load Winston on the server.
const logger: LoggerLike = typeof window === 'undefined' ? createWinstonLogger() : consoleLogger

export function errorWithStack(message: string, err: unknown, meta: LogMeta = {}) {
  const error = err instanceof Error ? err : new Error(String(err))
  logger.error(message, {
    ...meta,
    stacktrace: error.stack?.split('\n'),
  })
}

export default logger
